import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Avatar, Menu, MenuItem, IconButton, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

// App konstanter
const APP_NAME = "Voice Victor";

const NavBar: React.FC = () => {
  const { currentUser, logOut, userType, userName } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    try {
      await logOut();
      navigate('/login');
    } catch (error) {
      console.error('Fejl ved logud:', error);
    }
  };

  const handleDashboard = () => {
    if (userType === 'agent') {
      navigate('/agent-dashboard');
    } else if (userType === 'management') {
      navigate('/management-dashboard');
    }
    handleClose();
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {t('navbar.appName')}
        </Typography>
        
        {currentUser ? (
          <Box display="flex" alignItems="center">
            {userType === 'agent' && (
              <Button color="inherit" onClick={() => navigate('/agent-dashboard')}>
                {t('common.dashboard')}
              </Button>
            )}
            
            {userType === 'management' && (
              <>
                <Button color="inherit" onClick={() => navigate('/management-dashboard')}>
                  {t('common.dashboard')}
                </Button>
                <Button color="inherit" onClick={() => navigate('/settings')}>
                  {t('common.settings')}
                </Button>
              </>
            )}
            
            <LanguageSelector />
            
            <IconButton
              size="large"
              aria-label="konto for nuværende bruger"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar 
                sx={{ width: 32, height: 32, bgcolor: 'secondary.main' }}
              >
                {currentUser.email ? currentUser.email.charAt(0).toUpperCase() : '?'}
              </Avatar>
            </IconButton>
            
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleDashboard}>{t('common.dashboard')}</MenuItem>
              <MenuItem onClick={() => { handleClose(); navigate('/profile') }}>{t('common.profile')}</MenuItem>
              <MenuItem onClick={handleLogout}>{t('common.logout')}</MenuItem>
            </Menu>
          </Box>
        ) : (
          <Box display="flex" alignItems="center">
            <LanguageSelector />
            <Button color="inherit" onClick={() => navigate('/login')}>
              {t('common.login')}
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default NavBar; 